import { types } from 'mobx-state-tree';

export const AttachmentModel = types
  .model('AttachmentModel', {
    gid: types.maybe(types.string),
    content: types.maybe(types.string),
    contentType: types.string,
    fileName: types.string,
    uploadedBy: types.maybe(types.integer),
    uploadDate: types.maybe(types.string),
    uid: ''
  })
  .actions(self => ({
    updateUid(uid) {
      self.uid = uid;
    },
    updateContent(content) {
      self.content = content;
    }
  }));
